export function dropSpec({ ref, index, move, onDrop }) {
  return {
    accept: 'GoalCard',
    hover: (item, monitor) => {
      if (!ref.current) return;

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) return;

      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientX = clientOffset.x - hoverBoundingRect.left;

      if (dragIndex < hoverIndex && hoverClientX > hoverMiddleX) return;
      if (dragIndex > hoverIndex && hoverClientX < hoverMiddleX) return;

      move(item.index, index);
      // eslint-disable-next-line no-param-reassign
      item.index = hoverIndex;
    },
    drop: onDrop,
  };
}
export function dragSpec({ index }) {
  return {
    item: { type: 'GoalCard', index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  };
}
